import React, { useState, useEffect } from 'react'
import { useQuery } from 'react-query'
import { useForm } from 'react-hook-form';

import Filter from './filter'
import Map from './map'
import List from '../map/list'
import Teaser from './teaser'
import { parse } from "wkt"

import { deburr, orderBy } from 'lodash'

const CrownPastoralLandSnapshotApp = ({ endpoint = "/api/charts/cpl", noResultsText, ...settings }) => {

  const { register, handleSubmit, resetField } = useForm();
  const [ filtered, setFiltered ] = useState([]);
  const [ hidden, setHidden ] = useState(false);
  const [ filters, setFilters ] = useState({
    keywords: '',
    district: '',
    stage: '',
    tenure: 'all'
  })

    const { isLoading, error, data } = useQuery(`linz-map-snapshot__cpl`, async () => {
      const info = await fetch(`/api/charts/cpl-count`);

      if (info.ok === false) {
        return [];
      }

      const { requests } = await info.json();

      const chunks = await Promise.allSettled(
        Array(requests).fill().map(async (_, i) => {
          const req = await fetch(`${endpoint}?p=${i}`)
          if (req.ok) {
            return await req.json();
          }
          throw req;
        })
      ).catch(err => {
        console.error({ err })
      })

      let settled = chunks.filter(chunk => chunk.status === 'fulfilled').map(chunk => chunk.value);

      const flattenedItems = settled.flatMap(chunk => chunk.items);

      return flattenedItems.filter(item => item.geodata).map(item => ({
        ...item,
        isCloseToAntimeridian: item.longitude < -175
      }))
      }
    )

    useEffect(() => {
      if(data && data.length) {
        setFiltered(data);
      }
    }, [data]);

    useEffect(() => {
      if(!data) {
        return;
      }
      let clone = [...data];
      if(filters?.keywords.length > 2) {
        // do filtering
        let keywords = deburr(filters.keywords).toLowerCase();
        clone = clone.filter(({ title }) => deburr(title).toLowerCase().includes(keywords.toLowerCase()))
      }
      if(filters?.district.length > 0) {
        clone = clone.filter(({ region }) => region === filters.district)
      }
      if(filters?.type.length > 0) {
        clone = clone.filter(({ type }) => type === filters.type)
      }

      setFiltered(clone);
    }, [filters]);


    if(isLoading) {
        return <div className="spinner">&nbsp;</div>;
    }

    const districts = [...new Set(data.map(({ region }) => region))].filter(item => item);
    const types = [...new Set(data.map(({ type }) => type))].filter(item => item);

    const onFilter = ({ keywords, district, type }) => {
      setFilters({
        keywords: keywords || '',
        district: district || '',
        type: type || '',
      });
    }

    const onReset = () => {
      setFiltered(data);
      resetField('keywords')
      resetField('district')
      resetField('type')
      setFilters({
        keywords: '',
        district: '',
        type: ''
      })
    }

    let role = filters.keywords !== '' || filters.district !== '' ? 'status' : '';


    return (

      <div data-show-results={hidden ? false : true} className="crown-pastoral-land-snapshot__app map__app">

        <Filter
          id={`linz-map-snapshot__cpl`}
          districts={districts}
          types={types}
          register={register}
          handleSubmit={handleSubmit(onFilter)}
          onReset={onReset}
          filters={filters}
        />
        {filtered && (
          <div className="map__controls" role={role}>
            <h3>{`Showing ${filtered.length} location${filtered.length === 1 ? '' : 's'}`}</h3>
          </div>
        )}
        {filtered && (

          <div className={`map__list`}>
            <ul>
              {filtered.map(item => (
                <li key={item.nid}>
                  <article>
                     <strong><a href={item.path}>{item.title}</a></strong>
                     <dl>
                      <dt>District</dt>
                      <dd>{item.region}</dd>
                      <dt className="sr-only">Reference</dt>
                      <dd>{item.ref}</dd>
                    </dl>
                  </article>
                </li>
              ))}
            </ul>
          </div>
        )}

          {filtered && <Map data={filtered} {...settings} />}

      </div>
    )
}
export default CrownPastoralLandSnapshotApp
